import Kbd from './Kbd';

// export types
export type { KbdProps } from './Kbd';

// export components
export { Kbd };
export default Kbd;
